<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <listOperate :searchReq="searchReq"/>
      <el-form size="small" label-width="100px">
        <!-- 第一行 -->
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="案件批次号">
              <batch-selector v-model="searchReq.batchId" :batchNo="batchNoDefault" :testing="false"></batch-selector>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="还款来源">
              <el-select v-model="searchReq.dataSource" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in dataSource" :key="item.value" :label="item.label" :value="item.value" :title="item.label"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="还款时间">
              <el-date-picker v-model="searchReq.repayStartTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="至">
              <el-date-picker v-model="searchReq.repayEndTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 第二行 -->
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="还款状态">
              <el-select v-model="searchReq.status" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value" :title="item.label"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="公司名称" v-if="this.$partB()">
              <el-select v-model="searchReq.companyId" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in companyRes" :key="item.id" :label="item.companyName" :value="item.id" :title="item.companyName"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="padding15-tb text right">
        <el-button @click="searchReq.page = 1;repayList()" type="primary" size="mini" plain> <i class="fa fa-search"></i> 搜索</el-button>
        <el-button @click="reset" size="mini">重置</el-button>
      </div>
    </div>
    <div class="padding15 bg-content">
      <el-table max-height="500" :data="repayRes.list" v-loading="loading" size="small" :row-style="{cursor: 'pointer'}" highlight-current-row @sort-change="sort" empty-text="查无还款信息">
        <el-table-column label="进件号" min-width="130px" sortable="custom" property="aCaseId">
          <template slot-scope="scope">
            <el-button type="text" @click="detail(scope.row.caseId)" style="text-decoration:underline;">
              <span :title="scope.row.aCaseId" v-if="scope.row.aCaseId == '' || scope.row.aCaseId == null">--</span>
              <span :title="scope.row.aCaseId" v-else>{{scope.row.aCaseId}}</span>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="批次号" min-width="135px">
          <template slot-scope="scope">
            <span :title="scope.row.batchNo" v-if="scope.row.batchNo == '' || scope.row.batchNo == null">--</span>
            <span :title="scope.row.batchNo" v-else>{{scope.row.batchNo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="还款时间" min-width="150px" property="repayTime"/>
        <el-table-column label="还款金额" min-width="70px" property="repayAmount"/>
        <el-table-column label="减免金额" min-width="70px" property="remitAmount"/>
        <el-table-column label="剩余金额" min-width="70px" property="remainAmount"/>
        <el-table-column label="还款来源" min-width="105px">
          <template slot-scope="scope">
            <span v-if="scope.row.dataSource == ''">--</span>
            <span v-else-if="scope.row.dataSource === '0'">手动更新</span>
            <span v-else-if="scope.row.dataSource === '1'">导入更新接口更新</span>
            <span v-else-if="scope.row.dataSource === '2'">豹赋还款</span>
            <span v-else>{{scope.row.dataSource}}</span>
          </template>
        </el-table-column>
        <el-table-column label="还款状态" min-width="70px">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 'paying'">还款中</span>
            <span v-else-if="scope.row.status === 'paid'">已还款</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column label="还款方式" min-width="70px">
          <template slot-scope="scope">
            <span v-if="scope.row.repayType === '' || scope.row.repayType === null">--</span>
            <span v-else-if="scope.row.repayType === 'remittance'">汇款</span>
            <span v-else-if="scope.row.repayType === 'recharge'">充值</span>
            <span v-else-if="scope.row.repayType === 'deduction'">划扣</span>
            <span v-else>{{scope.row.repayType}}</span>
          </template>
        </el-table-column>
        <el-table-column label="还款人" min-width="60px" property="payName"/>
        <el-table-column label="甲方佣金" min-width="70px" property="partyA"/>
        <el-table-column label="乙方佣金" min-width="70px" property="partyB"/>
        <el-table-column label="还款凭证" min-width="100px">
          <template slot-scope="scope">
            <el-popover placement="right" title="还款凭证" width="200px" trigger="click" v-if="scope.row.filePath">
              <img :src="certificate" alt="" style="width:200px; height: auto;">
              <el-button type="warning" icon="el-icon-picture" circle slot="reference" @click="getPic(scope.row.filePath)"></el-button>
            </el-popover>
            <el-button type="warning" icon="el-icon-document" circle slot="reference" v-if="scope.row.evidenceUrl" @click="toEvidenceUrl(scope.row.evidenceUrl)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text center margin15-tb">
        <el-pagination background layout="prev, pager, next, sizes, total"
                       :total="repayRes.totalRecords" :page-sizes="[50, 100, 200]"
                       :page-size="searchReq.limit" :current-page="searchReq.page"
                       @current-change="currentChange" @size-change="sizeChange"/>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import BatchSelector from '../../../components/bussiness-select/BatchSelector';
import listOperate from './listOperate';

const Base64 = require('js-base64').Base64;

export default {
  inject: ['reload'],
  data() {
    return {
      loading: false,
      dataSource: [
        {
          'label': '导入更新接口更新',
          'value': 1
        },
        {
          'label': '豹赋还款',
          'value': 2
        },
        {
          'label': '手动更新',
          'value': 0
        }
      ],
      status: [
        {
          'label': '还款中',
          'value': 'paying'
        },
        {
          'label': '已还款',
          'value': 'paid'
        }
      ],
      companyRes: [],
      searchReq: {
        page: 1,
        limit: 50,
        order: 'repayTime',
        sort: 'desc',
        // 搜索条件
        companyId: [],
        batchId: [],
        dataSource: [],
        status: [],
        repayStartTime: null,
        repayEndTime: null
      },
      repayRes: { 'totalRecords': 0, list: [] },
      batchNoDefault: [],
      certificate: null
    };
  },
  watch: {
  },
  mounted() {
    this.readCache();
    this.companyList();
  },
  methods: {
    toEvidenceUrl(url) {
      window.open(url);
    },
    detail(caseId) {
      window.open(`/main/case/detail/${Base64.encode(caseId)}`);
    },
    getPic(filePath) {
      this.certificate = null;
      if (filePath) {
        const uri = `/caseDetail/picForAjax?path=${filePath}`;
        this.$ajax({
          method: 'GET',
          url: uri,
          contentType: 'application/json'
        }).then((temp) => {
          this.certificate = `data:image/png;base64,${temp.data}`;
        });
      }
    },
    companyList() {
      this.$ajax({
        method: 'GET',
        url: '/company/list'
      }).then((res) => {
        this.companyRes = res.data;
      });
    },
    repayList() {
      this.loading = true;
      this.$ajax({
        method: 'POST',
        url: '/pay/list',
        data: this.searchReq
      }).then((res) => {
        this.repayRes = res.data;
        this.writeCache();
        this.loading = false;
      });
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.repayList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.repayList();
    },
    sort(column) {
      console.warn('sort');
      const prop = column.prop;
      const order = column.order;
      this.searchReq.order = prop === null ? 'repayTime' : prop;
      if (order === 'descending') {
        this.searchReq.sort = 'desc';
      }
      if (order === 'ascending') {
        this.searchReq.sort = 'asc';
      }
      this.repayList();
    },
    // 搜索成功，写入缓存
    writeCache() {
      localStorage.setItem('paySearchCompanyId', this.$account().companyId);
      const paySearchReqCache = JSON.stringify(this.searchReq);
      localStorage.setItem('paySearchReqCache', paySearchReqCache);
    },
    // 进入页面读取缓存
    readCache() {
      const companyId = localStorage.getItem('paySearchCompanyId');
      const paySearchReqCache = localStorage.getItem('paySearchReqCache');
      if (this.$account().companyId === Number(companyId) && paySearchReqCache) {
        this.reqCopy(paySearchReqCache);
      } else {
        localStorage.removeItem('paySearchCompanyId');
        localStorage.removeItem('paySearchReqCache');
        this.reset();
      }
      this.repayList();
    },
    reset() {
      const date = moment(Date.now()).format('YYYY-MM-DD');
      this.searchReq.page = 1;
      this.searchReq.limit = 50;
      this.searchReq.order = 'repayTime';
      this.searchReq.sort = 'desc';
      this.searchReq.companyId = [];
      this.searchReq.batchId = [];
      this.searchReq.dataSource = [0, 1, 2];
      this.searchReq.status = ['paying', 'paid'];
      this.searchReq.repayStartTime = `${date} 00:00:00`;
      this.searchReq.repayEndTime = `${date} 23:59:59`;
      this.writeCache();
      this.reload();
    },
    reqCopy(jsonStr) {
      const temp = JSON.parse(jsonStr);
      if (temp) {
        this.searchReq.page = temp.page ? temp.page : 1;
        this.searchReq.limit = temp.limit ? temp.limit : 50;
        this.searchReq.order = temp.order ? temp.order : 'repayTime';
        this.searchReq.sort = temp.sort ? temp.sort : 'desc';
        this.searchReq.companyId = temp.companyId ? temp.companyId : [];
        this.searchReq.batchId = temp.batchId ? temp.batchId : [];
        this.searchReq.dataSource = temp.dataSource ? temp.dataSource : [];
        this.searchReq.status = temp.status ? temp.status : [];
        this.searchReq.repayStartTime = temp.repayStartTime ? temp.repayStartTime : null;
        this.searchReq.repayEndTime = temp.repayEndTime ? temp.repayEndTime : null;
        // 默认
        this.batchNoDefault = temp.batchId ? temp.batchId : [];
      }
    }
  },
  components: {
    listOperate, BatchSelector
  }
};
</script>
<style lang="less" scoped>
  .rate-component {
    span {
      display: inline-block;
      width: 20px;
      vertical-align: middle;
    }
    & > div {
      display: inline-block;
      width: 160px;
      vertical-align: middle;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/main/repay/list.vue